import { render, staticRenderFns } from "./cards-list.vue?vue&type=template&id=48eacd08&scoped=true&"
import script from "./cards-list.component.ts?vue&type=script&lang=ts&"
export * from "./cards-list.component.ts?vue&type=script&lang=ts&"
import style0 from "./cards-list.vue?vue&type=style&index=0&id=48eacd08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48eacd08",
  null
  
)

export default component.exports